<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">廣告列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">首頁</li>
              <li class="breadcrumb-item active">廣告列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter">
              <el-button
                @click="selectByType('')"
                :class="{ current: '' == selectValue }"
                >全部</el-button
              >
              <el-button
                @click="selectByType('NotStarted')"
                :class="{ current: 'NotStarted' == selectValue }"
                >未開始</el-button
              >
              <el-button
                @click="selectByType('InPublication')"
                :class="{ current: 'InPublication' == selectValue }"
                >刊登中</el-button
              >
              <el-button
                @click="selectByType('Expired')"
                :class="{ current: 'Expired' == selectValue }"
                >已过期</el-button
              >
              <el-button
                @click="selectByType('NotShow')"
                :class="{ current: 'NotShow' == selectValue }"
                >不顯示</el-button
              >
            </div>
          </div>
          <div class="col-sm-2">
            <button
              @click="addOrUpdate(0)"
              type="button"
              class="btn btn-block btn-primary btn-sm"
            >
              <i class="nav-icon fas fa-pen fa-sm mr-1"></i>新增
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form ref="form" label-width="80px" @submit.native.prevent>
                  <el-row>
                    <el-col
                      :md="{ span: 6, offset: 18 }"
                      :sm="{ span: 8, offset: 16 }"
                      :xs="{ span: 14, offset: 10 }"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="searchText"
                          clearable
                          @input="searchTextQry"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="廣告名稱">
                    <template slot-scope="scoped">
                      <el-tooltip placement="right">
                        <div slot="content">
                          <img
                            :src="scoped.row.sgL_ImageUrl"
                            style="width: 100%; max-width: 600px"
                          />
                        </div>
                        <a
                          v-if="
                            scoped.row.sgL_ImageClickUrl.startsWith('https') ||
                            scoped.row.sgL_ImageClickUrl.startsWith('http')
                          "
                          target="_blank"
                          :href="scoped.row.sgL_ImageClickUrl"
                        >
                          {{ scoped.row.sgL_ImageTitle }}
                        </a>
                        <a
                          v-else
                          target="_blank"
                          :href="`http://${scoped.row.sgL_ImageClickUrl}`"
                        >
                          {{ scoped.row.sgL_ImageTitle }}
                        </a>
                      </el-tooltip>
                      <!-- <span class="b-ad-name">
                        <a
                          v-if="
                            scoped.row.sgL_ImageClickUrl.startsWith('https') ||
                            scoped.row.sgL_ImageClickUrl.startsWith('http')
                          "
                          target="_blank"
                          :href="scoped.row.sgL_ImageClickUrl"
                        >
                          <img
                            :src="scoped.row.sgL_ImageUrl"
                            style="display: none"
                          />
                          {{ scoped.row.sgL_ImageTitle }}
                        </a>
                        <a
                          v-else
                          target="_blank"
                          :href="`http://${scoped.row.sgL_ImageClickUrl}`"
                        >
                          <img
                            :src="scoped.row.sgL_ImageUrl"
                            style="display: none"
                          />
                          {{ scoped.row.sgL_ImageTitle }}
                        </a>
                      </span> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="廣告商" prop="sgL_BrandName">
                  </el-table-column>
                  <el-table-column label="刊登位置" prop="sgL_TypeF">
                  </el-table-column>
                  <el-table-column label="狀態" prop="sgL_StatusF">
                    <!-- <template slot-scope="scoped">
                      <span v-if="scoped.row.sgL_IsShow" class="b-published">
                        刊登中
                      </span>
                      <span v-else class="b-unpublished"> 已過期 </span>
                    </template> -->
                  </el-table-column>
                  <el-table-column label="開始日期" prop="sgL_StartTimeF">
                  </el-table-column>
                  <el-table-column label="結束日期" prop="sgL_EndTimeF">
                  </el-table-column>
                  <el-table-column
                    label="發布者"
                    prop="sgL_CreateName"
                  ></el-table-column>
                  <el-table-column
                    label="發布日期"
                    prop="sgL_CreateTimeM"
                  ></el-table-column>
                  <el-table-column label="點擊量/瀏覽量">
                    <template slot-scope="scope">
                      <span
                        >{{ scope.row.sgL_ClickCount }} /
                        {{ scope.row.sgL_ViewCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="轉化率" prop="sgL_ViewCountF">
                  </el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="addOrUpdate(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="delfunc(scope.row.id)"
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "true",
          label: "顯示中",
        },
        {
          value: "false",
          label: "隱藏中",
        },
      ],
      searchText: "",
      selectValue: "",
      BannerList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getBannerList();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    hover() {
      $(".b-ad-name a").mouseover(function () {
        $(".b-ad-name a img").css("display", "none"); // hide all images
        $(this).find("img").css("display", "inline-block"); // show current hover image
      });
      $(".b-ad-name a").mouseout(function () {
        $(".b-ad-name a img").css("display", "none"); // hide all images
      });
    },
    delfunc(id) {
      if (id > 0) {
        this.$confirm("確認刪除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              Id: id,
            };
            this.$api.permissionApi.deleteBanner(params).then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: "刪除成功",
                });
                this.getBannerList();
              } else {
                Message({
                  type: "error",
                  message: res.data.error.message,
                });
              }
            });
          })
          .catch(() => {});
      }
    },
    addOrUpdate(id) {
      if (id > 0) {
        this.$router.push({ name: "CreateBanner", query: { Id: id } });
      } else {
        this.$router.push({ name: "CreateBanner" });
      }
    },
    getBannerList() {
      this.loading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_ImageTitle: this.searchText,
        SGL_Status: this.selectValue,
      };
      this.$api.permissionApi
        .getBannerList(params)
        .then((res) => {
          if (res.data.success) {
            this.BannerList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
            this.$nextTick(() => {
              this.hover();
            });
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    selectByType(status) {
      this.selectValue = status;
    },
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getBannerList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.BannerList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}

/* .b-ad-name a {
  display: inline-block;
  position: relative;
}
.b-ad-name a img {
  display: none;
  position: absolute;
  z-index: 1100;
  min-height: 90px;
  max-height: 500px;
  top: 50%;
  left: calc(100% + 1rem);
  transform: translateY(-50%);
} */
</style>


// WEBPACK FOOTER //
// src/components/AdminBanner/BannerList.vue